export default {
    'download.modal.title': '用户信息确认',
    'download.modal.tip': '为更好地提供数据服务，请填写以下信息',

    'download.modal.profession': '职业',
    'download.modal.student': '学生',
    'download.modal.employee': '职员',
    'download.modal.researcher': '研究员',
    'download.modal.freelancer': '自由职业者',
    'download.modal.other': '其他',

    'download.modal.org': '机构/组织',

    'download.modal.email': '邮箱',

    'download.modal.research.direction': '研究方向',
    'download.modal.large.model': '大模型',
    'download.modal.artificial.intelligence': '人工智能',
    'download.modal.machine.learning':'机器学习',
    'download.modal.NLP': '自然语言处理',
    'download.modal.CV': '计算机视觉',
    'download.modal.autonomous.driving': '自动驾驶',
    'download.modal.robotic.learning':'机器人学习',
    'download.modal.medical.health': '医疗健康',
    'download.modal.smart.retail': '智慧零售',
    'download.modal.intelligent.finance': '智慧金融',
    'download.modal.others': '其他',

    'download.modal.required.org': '请输入有效的组织/机构名称',
    'download.modal.rule.org': '输入字符受限制',
    'download.modal.limit.org': '最多输入50个字',
    'download.modal.required.email': '请输入有效的电子邮件地址',
    'download.modal.rule.email': '邮箱格式错误',
    'download.modal.required.profession': '请选择一个选项',
    'download.modal.required.research.direction': '请至少选择一个选项'
};